import createAxiosInstance from "./LambdaApiAdministracion";
import { ENVIROMENT } from "../utilities";

export async function fetchAdmin(company, ceco, rol, tokenProd) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon?company=${company}&ceco=${ceco}&rol=${rol}`
      : `home/admon?company=${company}&ceco=${ceco}&rol=${rol}`;
  // PARA PROBAR BACKEND LOCAL
  // const url =  ENVIROMENT === "dev" ? `home/admon?company=${company}&ceco=${ceco}&rol=${rol}`: `home/admon?company=${company}&ceco=${ceco}&rol=${rol}`
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: url,
    /*headers: {
      "Content-Type": "application/json",
    },*/
  };
  return axiosInstance(requestConfig);
}

export async function fetchRolByEmail(email) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/directivo?correo=${email}`
      : `home/admon/directivo?correo=${email}`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}

export async function fetchAllDivision() {
  const axiosInstance = await createAxiosInstance();
  const url = ENVIROMENT === "dev" ? `/admon/divisionales` : `home/admon/divisionales`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}

export async function fetchAllDivisionCM(marca) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/divisionalcm?marca=${marca}`
      : `home/admon/divisionalcm?marca=${marca}`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}

export async function fetchDivisionalByEmail(email) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/divisional?correo=${email}`
      : `home/admon/divisional?correo=${email}`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}

export async function fetchRegionByEmail(email) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/regional?correo=${email}`
      : `home/admon/regional?correo=${email}`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}

export async function fetchDistritoByEmail(email) {
  const axiosInstance = await createAxiosInstance();
  const url =
    ENVIROMENT === "dev"
      ? `/admon/distrito/sucursales?correo=${email}`
      : `home/admon/distrito/sucursales?correo=${email}`;
  const requestConfig = {
    method: "GET",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(requestConfig);
}
